import userManager from 'src/auth/userManager';
function errorEnhancer(promiseFunc) {
    return (params) => {
        return promiseFunc(params).catch(((err) => {
            if (err.response?.status === 401) {
                userManager.removeUser();
                window.location.reload();
            }
            throw err;
        }));
    };
}
export default errorEnhancer;
